import {
  getEnvironmentFromHostname,
  toApiBaseUrl,
} from "@zymego/portals-utils";

/**
 * The API each deployed admin host talks to. It is read from the hostname, not
 * the build, because one build serves several hosts: `admin.demo.zymego.app`
 * is served by the production build, and with the production URL baked in it
 * called the production API, whose CORS rejects the demo origin.
 */
const DEPLOYED_API_ORIGINS = {
  demo: "https://api.demo.zymego.app",
  production: "https://api.zymego.app",
  staging: "https://api.staging.zymego.app",
} as const;

/**
 * The admin API's base URL, ending in a slash, which every admin endpoint is
 * resolved against (`trpc`, `graphql`, `auth`, the EHR booking-type REST
 * route). On a deployed host it follows the hostname; in development
 * `VITE_API_URL` names it (see `toApiBaseUrl`).
 */
function getAdminApiBaseUrl(): URL {
  const environment = getEnvironmentFromHostname(globalThis.location.hostname);

  return new URL(
    environment === "development"
      ? toApiBaseUrl(import.meta.env.VITE_API_URL)
      : `${DEPLOYED_API_ORIGINS[environment]}/admin/`,
  );
}

export { getAdminApiBaseUrl };
